import store from '../../store/store';

const NavigationGuards = {
    install(Vue, options) {
        Vue.guard = function (key, value) {
            if (store.getters['user/getUser']['tipo'] == value) {
                return true;
            }
            return false
        }
    }
};
export default NavigationGuards;
